import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import classnames from 'classnames';
import  Scheduling  from './sectionSchedulingFold/secSchedScheduling';
import  Projections  from './sectionSchedulingFold/secSchedProjections';
import { Form, Label, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import Toggle from 'react-toggle'; 
import Switch from 'react-switch';
import "react-toggle/style.css"
import moment from 'moment';
import { connect } from 'react-redux';

class SectionScheduling extends Component {
    static displayName = SectionScheduling.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            pageType: false, //false for Scheduling mode, true for Projection mode. Change which is set here for default landing mode.
            activeTerms: [],
            SchedProjBool: false,
            openTermStatus: false,
            activeDepartment: "",
            openTermYear: [".", ","],
            termToOpen: "",
            termInfo: [",", "."],
            openTermModal: false,
            openMessage: "",
            roomManageModal: false,
            roomManagement: [],
            roomManageKey: 1,
            secSchedKey: 1
        }
        this.testPermission();
        this.getActiveTerms();
        this.getYearTermsToOpen();
        this.toggleSwitch = this.toggleSwitch.bind(this);
        this.closeSemester = this.closeSemester.bind(this);
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            username: this.props.reduxData.userInfo.username,
        });
        var dept = this.props.reduxData.userInfo.level.pk
        //this.recordComingHere();
        this.testPermission();
        this.getActiveTerms();
        this.getYearTermsToOpen();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "18",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "18"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        
    }

    async getActiveTerms() { //We only need to retrieve two pieces of information for this top-level component: what terms are open in the PermittedYearTerms table, and what terms are eligible to be opened
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        var dept = this.props.reduxData.userInfo.level.pk;
        dept = dept.substring(0, dept.indexOf('-') - 1);
        this.setState({
            openTermModal: false,
            secSchedKey: this.state.secSchedKey++,
            loading: true
        })
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('ActiveTerms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            activeTerms: data,
            activeDepartment: dept,
            loading: false
        })
        this.manageRoomType();
    }

    async getYearTermsToOpen() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('FindSemestersToOpen', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            openTermYear: data
        })
        this.manageRoomType();
    }

    async manageRoomType() {
        if (this.state.activeDepartment == "REGISTRAR") {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            this.props.updateFetchTime();
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            const response = await fetch('GetRoomtype', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.setState({
                roomManagement: data
            })
        }
    }

    componentDidMount() {
        
    }

    toggleSwitch() {//This handles the switch that flips between Scheduling and Projections mode. this.state.pageType controls both the switch position and the displayed component
        this.setState({
            pageType: !this.state.pageType
        })
    }

    toggleTerm() {
        this.setState({
            openTermStatus: !this.state.openTermStatus
        })
    }

    async openTermToggle(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetSesPerID: e.target.value
        }
        const response = await fetch('YearTermInfoSS', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            openTermStatus: true,
            termToOpen: e.target.value,
            termInfo: data
        })
    }

    async finalizePublish(e) { //I don't technically need the event as a parameter here since I'm using the state value assigned in this.openTermToggle(e), it's here as a vestigal parameter
                                //from when this was the main function that was first run. When I moved this behind a modal I needed a new source of the target data, but the parameter stayed
                                //largely due to not knowing whether I'm going to need it again in the future. Better to have and not need than to need and not have.
        this.toggleTerm();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetSesPerID: this.state.termToOpen
        }
        const response = await fetch('OpenTerm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();//This fetch will either retrieve an Open or Insert depending on whether it needed to create section in the process of opening, which will dictate
        //the message the page tells the user
        //localStorage.setItem("lastFetch", moment());
        if (data.response == "open") {
            this.setState({
                openMessage: "The semester has been opened without importing from projections",
                openTermModal: true
            })
        }
        if (data.response == "insert") {
            this.setState({
                openMessage: "The semester has been opened and projections have been imported",
                openTermModal: true
            })
        }
    }

    async closeSemester(e) { 
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: e
        }
        const response = await fetch('CloseSemester', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //window.location.reload(true); //window.location.reload(true) is translated in English to "I tried to do this like normal people and almost turned testrigel into slag so we're brute forcing it"
        //UPDATE 20230327: With switching from routing to conditional rendering for choosing which "page" to display, this won't work well anymore. It'll send the user back to the Home screen.
        this.getActiveTerms();
        this.getYearTermsToOpen();
    }

    confirmOpen() {
        this.setState({
            openTermModal: !this.state.openTermModal
        })
    }

    toggleRoomManagement() {
        this.setState({
            roomManageModal: !this.state.roomManageModal
        })
    }

    async checkRoomtype(code) {
        //console.log("clicking: " + code);
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            target: code
        }
        const response = await fetch('UpdateRoomtype', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            roomManagement: data,
            roomManageKey: this.state.roomManageKey + 1
        })
    }

    handleBigKey = (dataFromChild) => {
        this.getActiveTerms();
    }

    //In order to properly manage having a Scheduling and Projections mode on this page, I've made those modes child components of the main component that defines Section Scheduling at
    //the top level. Therefore, this top level component that's being routed to from App.js has only the functions of displaying and managing open sections, managing navigation to here 
    //and validation, and operating the switch to decide which mode is currently active.

    render() {
        if (this.state.permissionFlag == false) {
            //return <Redirect to='/accessForbidden' />
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        let displayInfo = <div></div> //Theoretically, if this.state.pageType was ever neither true nor false, this line would mean the whole page would be pretty much blank.
                                        //If that should happen, debug by turning off the CERN particle collider and work to reassert normal laws of physics.
                                        //UPDATE 20230217: We're adding a loading check which will cause this to be here until the user information finishes loading
        if (this.state.pageType == false && !this.state.loading) {
            displayInfo = <Scheduling userLevel={this.props.reduxData.userInfo.level.pk} key={this.state.secSchedKey} refreshAll={this.handleBigKey} />
        }
        else if (this.state.pageType == true && !this.state.loading) {
            displayInfo = <Projections userLevel={this.props.reduxData.userInfo.level.pk} />
        } 

            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div key={this.state.bigKey}>
                            <Modal isOpen={this.state.roomManageModal} toggle={this.toggleRoomManagement.bind(this)} size="xl">
                                <ModalHeader toggle={this.toggleRoomManagement.bind(this)}>Room Type Management</ModalHeader>
                                <ModalBody>
                                    <div className="d-flex flex-wrap" style={{ maxWidth: 1200 }} key={this.state.roomManageKey}>
                                        {this.state.roomManagement.map((item) => (
                                            <div key={item.code} style={{ "width": "20%" }} >
                                                <Input type="checkbox" disabled={!item.active} checked={item.selected} onClick={(e) => this.checkRoomtype(item.code)} />{item.fullname} &emsp;
                                            </div>
                                        ))}
                                    </div>
                                </ModalBody>
                                <ModalFooter><Button onClick={this.toggleRoomManagement.bind(this)}>Close</Button></ModalFooter>
                            </Modal>
                            <Modal isOpen={this.state.openTermModal} toggle={this.confirmOpen.bind(this)}> 
                                {/*These modals can go anywhere, but towards the end of this I've realized putting them at the top of render(){return()} helps visually distinguish them from*/}
                                {/*everything else going on.*/}
                                <ModalHeader toggle={this.confirmOpen.bind(this)}>
                                    Open Term Status
                                </ModalHeader>
                                <ModalBody>
                                    {this.state.openMessage}
                                    {/*This message will contain the response dictating whether or not there were any projections imported to Scheduling when the section was opened.*/}
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={() => this.getActiveTerms()} color="primary">Show Me</Button>
                                </ModalFooter>
                                </Modal>
                            <Table bordered>
                                {/*Making this a bordered table is the easiest way to have the banner look at the top to visually delineate it from the rest of the page*/}
                                <tr>
                                    <td>
                                        <div className="inlineCustom">
                            Semesters Open for Scheduling: {this.state.activeTerms.map(term => (
                                <div className="inlineCustom"><Badge color={term.editable} className="inlineCustom">{term.semester}<Button close onClick={() => this.closeSemester(term.semester)} hidden={this.state.activeDepartment == "REGISTRAR" ? false : true} /></Badge>&nbsp;</div>
                                ))}
                                            <br />
                                        </div>
                                        <div className="inlineCustom" hidden={this.state.activeDepartment == "REGISTRAR" ? false : true}>
                                            <Input type='select' name='open' id='open' defaultValue='DEFAULT' onChange={this.openTermToggle.bind(this)} >
                                                <option value='DEFAULT' disabled={true}>Open Semester...</option>
                                                {this.state.openTermYear.map(term => (
                                                    <option value={term.sesperid}>{term.yearterm}</option>
                                                    ))}
                                            </Input>
                                            

                                            <Modal isOpen={this.state.openTermStatus} toggle={this.toggleTerm.bind(this)}>
                                                {/*Even though this modal appears below the other one, this will actually display first in the workflow.*/}
                                                {/*This modal is asking for confirmation that you want to open this term, and the other is letting you know the term was opened.*/}
                                    <ModalHeader toggle={this.toggleTerm.bind(this)}>Open Term</ModalHeader>
                                    <ModalBody>      
                                                    You are about to open {this.state.termInfo.name} , which has {this.state.termInfo.totalprojections} projections.<br />
                                                    This action cannot be reversed. Are you sure you want to do this?
                                    </ModalBody>
                                                <ModalFooter>
                                                    <Button onClick={this.finalizePublish.bind(this)} color="primary">Yes</Button>
                                                    <Button onClick={this.toggleTerm.bind(this)}>Not yet</Button>
                                                </ModalFooter>
                                </Modal>
                                        </div>
                                    {/*    <div className="rightAlignCustom" style={{ visibility: this.state.activeDepartment == "REGISTRAR" ? 'visible' : 'hidden' }}><Button outline onClick={() => this.toggleRoomManagement()}>Room Type Management</Button></div>&nbsp;*/}
                                    </td></tr>
                            </Table>
                            <div className='d-flex float-right' style={{ float: 'right' }}>
                                Scheduling &nbsp;<Switch uncheckedIcon={false} checkedIcon={false} onChange={this.toggleSwitch} checked={this.state.pageType} onColor={'#888'} height={25} width={50} /> &nbsp; Projections
                            </div>
                            {displayInfo}
                            {/*displayInfo will either be the Scheduling child component or the Projections child component based on the toggle above*/}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(SectionScheduling);